import * as http from "@/utils/request";
import axios from 'axios';
import {
  getLoginData,
  getParents,
  getRoleId,
  getUserName,
  getRoleIdRenon
} from "@/utils/auth";
import {
  parseTime
} from "@/utils/index";
import moment from 'moment';
import {
  getLastData
} from "@/services/commands";


export function list(params = {}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let parentId = userInfo.parent_id;

  const queryParams = { ...params };

  // 过滤清洗 ids 参数：当 ids 为 "All" / "all" 时直接移除 ids 参数
  if (queryParams.ids) {
    if (typeof queryParams.ids === 'string') {
      const filteredIds = queryParams.ids
        .split(',')
        .map(id => id.trim())
        .filter(id => id && id.toLowerCase() !== 'all')
        .join(',');

      if (filteredIds) {
        queryParams.ids = filteredIds;
      } else {
        delete queryParams.ids;
      }
    } else if (String(queryParams.ids).toLowerCase() === 'all') {
      delete queryParams.ids;
    }
  }

  if (queryParams.userId) {
    return http.get(`/v1/things/tenants/${tenantId}/users/${queryParams.userId}/things`, {
      current_page: queryParams.current_page || 1,
      page_size: queryParams.page_size || 100,
      user_id: queryParams.userId,
      ...queryParams
    })
  } else {
    return http.get(`/v1/things/tenants/${tenantId}/things`, {
      current_page: queryParams.current_page || 1,
      page_size: queryParams.page_size || 100,
      user_id: queryParams.userId,
      ...queryParams
    })
  }
  // return http.get("v1/devices", params)
}

export function listCount(filter) {

  return http.get("/v1/devices", {
    aggregation: "count",
    "descend": true,
    filter: filter
  })
}

export function findSelectList(params = {}) {

  return list({
    current_page: params.current_page || 1,
    page_size: params.page_size || 100,
    userId: params.userId,
  })
}


export function findDevList(param = {}) {
  return list({
    current_page: param.current_page,
    page_size: param.page_size,
    // filter: '{"devtype":"HE_BAT","desc":{"$regex":"'+getUserName()+'","$options":"i"},"$or":[{"parents":"' + getUserName() + '"},{"subusers":"' +
    //   getUserName() + '"}]}',
    // fields: param.fields||'',
    // descend: true
  });
  //
}

export function findAllDevice(param = {}) {
  return list({
    skip: param.skip,
    limit: param.limit,
    filter: JSON.stringify(param.filter) || "",
    descend: true
  });
}

//设备列表页
export function findDevList2(param = {}) {
  // let filter = {
  //   "$and": [],
  //   // "$or": [{"parents": getUserName()}, {"subusers": getUserName()}]
  // };
  // if (param.devid) {
  //   filter["devid"] = {
  //     "$regex": param.devid,
  //     "$options": "i"
  //   };
  // }
	// filter["devtype"] = "HE_BAT";
  // if (param.status !== '') {
  //   filter["status"] = param.status;
  // }
  // if (param.user) {
  //   filter["$and"].push({
  //     "subusers": param.user
  //   })
  //   filter["$and"].push({
  //     "desc": {
  //       "$regex": param.user,
  //       "$options": "i"
  //     }
  //   })
  // }
  // if(param.installer){
  //   filter["$and"].push({
  //     "subusers": param.installer
  //   })
  //   filter["$and"].push({
  //     "desc": {
  //       "$regex": param.installer,
  //       "$options": "i"
  //     }
  //   })
  // }
  // if (param.dateTime) {
  //   filter["$and"].push({
  //     "registertime": {
  //       "$gte": Number.parseInt(param.dateTime.getTime() / 1000)
  //     }
  //   });
  //   filter["$and"].push({
  //     "registertime": {
  //       "$lte": Number.parseInt(param.dateTime.getTime() / 1000 + (1 * 24 * 60 * 60))
  //     }
  //   });
  // }
  // if (param.installTime) {
  //   let installTime = `\\"installTime\\":\\"${parseTime(param.installTime,'{y}-{m}-{d}')}\\"`;
  //   filter["$and"].push({
  //     "desc": {
  //       "$regex": installTime,
  //       "$options": "i"
  //     },
  //   });
  // }
  // if (param.devname) {
  //   filter["devname"] = {
  //     "$regex": param.devname,
  //     "$options": "i"
  //   };
  // }
  // if (param.hardware) {
  //   filter["$and"].push({
  //     "M_R2.M_hwver": {
  //       "$regex": param.hardware,
  //       "$options": "i"
  //     }
  //   })
  // }
  // if (param.software) {
  //   filter["$and"].push({
  //     "M_R2.M_swver": {
  //       "$regex": param.software,
  //       "$options": "i"
  //     }
  //   })
  // }

  // if (getRoleIdRenon() != 0) {
  //   filter["desc"] = {
  //     "$regex": getUserName(),
  //     "$options": "i"
  //   };

  //   // filter["desc"] = '';

  //   // filter["$and"] = [
  //   //   {
  //   //   "$or": [
  //   //     {"desc": ""},
  //   //     {
  //   //       "desc": {
  //   //         "$regex": '\\"' + getUserName() + '\\"',
  //   //         "$options": "i"
  //   //       }
  //   //     }
  //   //   ]},
  //   //   {"$or" : [
  //   //     {
  //   //       "parents": getUserName()
  //   //     }, {
  //   //       "subusers": getUserName()
  //   //     },
  //   //   ]},
  //   // ]
  //   filter["$or"] = [{
  //     "parents": getUserName()
  //   }, {
  //     "subusers": getUserName()
  //   }]
  // }
  // if (filter["$and"].length == 0) {
  //   delete filter["$and"];
  // }

  // status过滤条件拼接
  let statusFilters = [];
  if (param.hardware) {
    
    statusFilters.push({status_name: "*.M_R2.M_hwver",
      op: "like",
      status_value: param.hardware});
  }
  if (param.software) {
    statusFilters.push({status_name: "*.M_R2.M_swver",
      op: "like",
      status_value: param.software});
  }

  // description过滤条件拼接
  let descFilters = {};
  if (param.installTime) {
    descFilters["installTime"] = parseTime(param.installTime, "{y}-{m}-{d}");
  }
  
  delete param.hardware;
  delete param.software;
  delete param.installTime;

  return list({
    devtype: param.devtype,
    current_page: param.current_page || 1,
    page_size: param.page_size || 100,
    status_filters: 
      statusFilters.length !== 0 ? JSON.stringify(statusFilters) : '',
    description: 
      Object.keys(descFilters).length !== 0 ? JSON.stringify(descFilters) : '',
    ...param
  });

}
//设备列表页
export function findDevList2Count(param) {
  let filter = {
    "$and": [],
    // "$or": [{"parents": getUserName()}, {"subusers": getUserName()}]
  };
  if (param.devid) {
    filter["devid"] = {
      "$regex": param.devid,
      "$options": "i"
    };
  }
  // if (param.devtype) {
  //   filter["devtype"] = param.devtype;
  // }
  filter["devtype"] = "HE_BAT";
  if (param.devname) {
    filter["devname"] = {
      "$regex": param.devname,
      "$options": "i"
    };
  }
  if (param.status !== '') {
    filter["status"] = param.status;
  }
  if (param.user) {
    filter["subusers"] = param.user;
    filter["desc"] = {
      "$regex": param.user,
      "$options": "i"
    };
  }
  if (param.dateTime) {
    filter["$and"].push({
      "registertime": {
        "$gte": Number.parseInt(param.dateTime.getTime() / 1000)
      }
    });
    filter["$and"].push({
      "registertime": {
        "$lte": Number.parseInt(param.dateTime.getTime() / 1000 + (1 * 24 * 60 * 60))
      }
    });
  }
  if (param.installTime) {
    let installTime = `\\"installTime\\":\\"${parseTime(param.installTime,'{y}-{m}-{d}')}\\"`;
    filter["$and"].push({
      "desc": {
        "$regex": installTime,
        "$options": "i"
      },
    });
  }
  if (param.hardware) {
    filter["$and"].push({
      "M_R2.M_hwver": {
        "$regex": param.hardware,
        "$options": "i"
      }
    })
  }
  if (param.software) {
    filter["$and"].push({
      "M_R2.M_swver": {
        "$regex": param.software,
        "$options": "i"
      }
    })
  }
  if (getRoleIdRenon() != 0) {
    filter["desc"] = {
      "$regex": getUserName(),
      "$options": "i"
    };
    filter["$or"] = [{
      "parents": getUserName()
    }, {
      "subusers": getUserName()
    }]
  }
  if (filter["$and"].length == 0) {
    delete filter["$and"];
  }
  return http.get("/v1/devices", {
    aggregation: "count",
    "descend": true,
    filter: JSON.stringify(filter)
  })
}

export function deviceDetail(devNo, devtype) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  return http.get2(`/v1/things/tenants/${tenantId}/things/${devNo}`);
}

export async function queryUserDeviceList(username) {
  var res = await http.get("/v1/devices", {
    skip: 0,
    limit: 1000,
    filter: '{"devtype":"HE_BAT","subusers":"' + username + '"}'
  });
  if (res && res.data && res.data.length > 0) {
    return res.data.map(item => {
      return item.devid;
    })
  }
  return [];
}

export async function queryUserDeviceList2(userId) {
  let filter = {
    "subusers": userId,
    // "desc": {
    //   "$regex": "\"" + userId + "\"",
    //   "$options": "i"
    // }
  };
  let fields = {
    "devid": 1,
    "devtype": 1,
    "devname": 1,
    "status": 1,
    "desc": 1
  };
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  var res = await http.get(`/v1/things/tenants/${tenantId}/users/${userId}/things`, {});
  if (res) {
    return res;
  }
  return [];
}


export async function queryUserDeviceList2Count(username) {
  let filter = {
    "subusers": username,
    // "desc": {
    //   "$regex": "\"" + username + "\"",
    //   "$options": "i"
    // }
  };
  return await http.get("/v1/devices", {
    aggregation: "count",
    filter: JSON.stringify(filter)
  });

}

// filter: {"devtype":"HE_BAT","devid":{"$regex":"","$options":"i"}}
export function count(filter) {
  return http.get("/v1/devices", {
    aggregation: "count",
    "descend": true,
    filter: '{"devtype":"HE_BAT","devid":{"$regex":"","$options":"i"},"$or":[{"parents":"' + getUserName() +
      '"},{"subusers":"' + getUserName() + '"}]}'
  })
}

export function deleteDev(devid, devtype) {
  return http.deleteRequest("/v1/devices/" + devid, {
    devtype
  })
}

// export function bindDevice(userName, deviceList) {
export function bindDevice(params = {}, urlParams = {}) {

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let userIds = urlParams.userIds;
  let auth_parent = urlParams.auth_parent;

  return http.postJSON(`/v1/things/tenants/${tenantId}/users/things?userIds=${userIds}&auth_parent=${auth_parent}`, params, true);

  // return http.putJSON("/v1/devices/bind", {
  //   devs: deviceList,
  //   subuser: userName
  // }, true)
}

export function bindDeviceById(params = {}, urlParams = {}) {

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let userId = userInfo.user_id;

  let infoModelId = urlParams.infoModelId;
  let thirdThingsId = urlParams.thirdThingsId;
  let checkNeighborUserThingsAuth = urlParams.checkNeighborUserThingsAuth || 1;
  let checkParentUserThingsAuth = urlParams.checkParentUserThingsAuth || 1;

  return http.putJSON(`/v1/things/tenants/${tenantId}/user/${userId}/things/auto-bind?infoModelId=${infoModelId}&thirdThingsId=${thirdThingsId}&checkNeighborUserThingsAuth=${checkNeighborUserThingsAuth}&checkParentUserThingsAuth=${checkParentUserThingsAuth}`, {}, true);

  return http.putJSON("/v1/devices/bind", {
    devids: deviceList,
    devs: [],
    subuser: userName,
    devtype: devtype
  }, true)
}

export function unBindDevice(params = {}, urlParams = {}) {

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let userIds = urlParams.userIds;

  // return http.deleteRequest(`/v1/things/tenants/${tenantId}/users/things`, params, true);
  return http.deleteBodyRequest(`/v1/things/tenants/${tenantId}/users/things?userIds=${userIds}`, params, true);

  

  return http.putJSON("v1/devices/unbind", {
    devs: deviceList,
    subuser: userName
  }, true)
}

export function getSubDevInfo(devid, devtype) {
  return http.get("v1/devices/subuser/"+devid,{
    devtype
  })
}

export function insert(params = {}) {

  let parents = [getLoginData().username];
  if (getLoginData().username !== "RENON") {
    parents = getLoginData().parents;
    parents.push(getLoginData().username)
  }

  return http.postJSON("/v1/devices", {
    ...params,
    "desc": "",
    "devgroup": "",
    "devtype": "HE_BAT",
    "gps": {
      "longitude": 0,
      "latitude": 0
    },
    "parents": parents,
    "subusers": parents
  })
}

// 获取设备的曲线的数据接口
export function queryDeviceChartData(params = {}, urlParams = {}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let infoModelId = urlParams.infoModelId
  let thingsId = urlParams.thingsId

  return http.postJSON(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/${thingsId}/history-aggregation`, params)
}


export function getParams(params = {}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let infoModelId = params.infoModelId;

  return http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/batch/data`, {
    begin_time: params.begin_time,
    end_time: params.end_time,
    category_id: params.category_id,
    thirdThingsIds: params.thirdThingsIds,
    topN: params.topN,
    exists: params.exists,
  });

  // return http.get("/v1/devtype/" + type, {})
}

export async function queryHistory2(devId, startTime, endTime, limit) {
  return http.get("/v1/devices/" + devId + "/data", {
    limit: limit,
    devid: devId,
    devtype: "HE_BAT",
    starttime: Number.parseInt(startTime),
    endtime: Number.parseInt(endTime),
    filter: "{}",
    descend: true,
    skip: 0
  })
}

export async function queryHistoryBySection(devId, fields, startTime, endTime, limit) {
  //{"E_hv":1,"E_lv":1,"E_lt":1,"E_ht":1,"E_soc":1,"E_cur":1,"E_tv":1,"time":1}
	var res = await http.get("/v1/devices/" + devId + "/data", {
    limit: limit,
    devid: devId,
    devtype: "HE_BAT",
    starttime: Number.parseInt(startTime),
    endtime: Number.parseInt(endTime),
    fields: JSON.stringify(fields),
    filter: JSON.stringify({
      "E_cumchgcap": {
        "$exists": true
      }
    }),
    descend: true,
    skip: 0
  });
  if (res && res.data) {
    res.data = res.data.sort((a, b) => {
      return a.time - b.time;
    })
  }
  return res;
}

export async function queryHistoryBySection2({devId, infoModelId, begin_time, end_time, category_id, thirdThingsIds, topN, exists, fields, devType = "HE_BAT", dataType = "data"}) {

  let userInfo = getLoginData();
    let tenantId = userInfo.tenant_id;

    var res = await http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/batch/data`, {
      begin_time,
      end_time,
      category_id,
      thirdThingsIds,
      topN,
      exists
    });
    return res;
    
  //{"E_hv":1,"E_lv":1,"E_lt":1,"E_ht":1,"E_soc":1,"E_cur":1,"E_tv":1,"time":1}
  let result = []
  for (let key in fields) {
    result.push(key);
  }

  var res = await http.get("/v1/devices/" + devId + "/data", {
    limit: limit,
    devid: devId,
    devtype: devtype,
    datatype: dataType,
    starttime: Number.parseInt(startTime),
    endtime: Number.parseInt(endTime),
    fields: JSON.stringify(fields),
    filter: JSON.stringify({
      [result[0]]: {
        "$exists": true
      }
    }),
    descend: true,
    skip: 0
  });
  if (res && res.data) {
    res.data = res.data.sort((a, b) => {
      return a.time - b.time;
    })
  }
  return res;
}

//查询导出数据
export async function queryExport({exists, infoModelId, topN, begin_time, end_time, category_id, thirdThingsIds, dataType = 'data'}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  // var res = await http.get("v1/devices/" + devId + "/data", {
  var res = await http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/batch/data`, {
    begin_time,
    end_time,
    category_id,
    thirdThingsIds,
    topN,
    exists
  });
  if (res && res.length) {
    res = res.sort((a, b) => {
      return a.timestamp - b.timestamp;
    })
  }
  return res;


  var res = await http.get("/v1/devices/" + devId + "/data", {
    limit: limit,
    devid: devId,
    devtype: devType,
    dataType: dataType,
    starttime: Number.parseInt(startTime),
    endtime: Number.parseInt(endTime),
    // fields: JSON.stringify(fields),
    filter: JSON.stringify({
      [fields]: {
        "$exists": true
      }
    }),
    descend: true,
    skip: 0
  });
  if (res && res.data) {
    res.data = res.data.sort((a, b) => {
      return a.time - b.time;
    })
  }
  return res;
}

export async function lastData({devId, infoModelId, begin_time, category_id, thirdThingsIds, topN, exists, fields, devType = "HE_BAT", dataType = "data"}) {
  let result = []
  for (let key in fields) {
    result.push(key);
  }

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  // var res = await http.get("v1/devices/" + devId + "/data", {
  var res = await http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/batch/data`, {
    begin_time,
    category_id,
    thirdThingsIds,
    topN,
    exists
  });
  return res;
}

export async function lastDataCell({devId, infoModelId, begin_time, category_id, thirdThingsIds, topN, exists, fields, devType = "HE_BAT", dataType = "data"}) {
  let result = []
  for (let key in fields) {
    result.push(key);
  }

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  // var res = await http.get("v1/devices/" + devId + "/data", {
  var res = await http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/batch/data`, {
    begin_time,
    category_id,
    thirdThingsIds,
    topN,
    exists
  });
  return res;
}

export async function queryHistory3(devId, limit, devtype) {

  return http.get("/v1/devices/" + devId + "/data", {
    limit: limit,
    devid: devId,
    devtype: devtype,
    filter: "{}",
    descend: true,
    skip: 0
  })
}
export function monthData(params, urlParams) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let infoModelId = urlParams.infoModelId;
  let thingsId = urlParams.thingsId;
  
  return http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/${thingsId}/_aggregations`, {
    agg_interval: params.agg_interval,
    agg_type: params.agg_type,
    begin_time: params.begin_time,
    category_id: params.category_id,
    data_points: params.data_points,
    data_type: params.data_type,
    end_time: params.end_time,
    event_name: params.event_name,
    exist_points: params.exist_points
  })

  return http.get("/v1/devices/" + devId + "/data", {
    devid: devId,
    devtype: devtype,
    filter: params.filter,
    descend: params.descend,
    fields: params.fields,
    aggregation: encodeURIComponent(params.aggregation),
    starttime: params.starttime,
    endtime: params.endtime,
  })
}

export async function queryHistory4(params, urlParams) {
  const res = await monthData(params, urlParams) || [];

  if (res.length > 0) {
    let list = res || [];
    let resultList = [];
    for (var i = 0; i < list.length; i++) {
      let item = {};
      item["time"] = moment(+list[i]["key"]).format("YYYY-MM-DD");
      urlParams.fields.forEach((item2) => {
        item["value"] = (list[i]["last"]["data"][item2] - list[i]["first"]["data"][item2]).toFixed(1);
      })
      resultList.push(item);
    }
    return resultList;
  }
}

export async function lastDataAllField({devId, infoModelId, begin_time, category_id, thirdThingsIds, topN, exists, fields, devType = "HE_BAT", dataType = "data"}) {

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  // var res = await http.get("v1/devices/" + devId + "/data", {
  var res = await http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/batch/data`, {
    begin_time,
    category_id,
    thirdThingsIds,
    topN,
    exists
  });
  return res;


  //{"E_hv":1,"E_lv":1,"E_lt":1,"E_ht":1,"E_soc":1,"E_cur":1,"E_tv":1,"time":1}
  var res = await http.get("v1/devices/" + devId + "/data", {
    "limit": 1,
    "devid": devId,
    "devtype": devType,
    "datatype": dataType,
    "filter": JSON.stringify({
      'M_soc': {
        "\$exists": true
      }
    }),
    "descend": true,
    "skip": 0
  });
  if (res != null && res["data"] != null && res["data"].length > 0) {
    return res["data"][0];
  }
  return {};
}





export async function queryHistory(devId, startTime, endTime, limit) {
  let start = new Date(startTime).getTime() / 1000;
  let end = new Date(endTime).getTime() / 1000;
  return queryHistory2(devId, start, end, limit)
}


export async function queryLastData(devId, devtype) {
  let res = await queryHistory3(devId, 100, devtype);
  let result = {};
  if (res.data) {
    for (let i = 0; i < res.data.length; i++) {
      let item = res.data[i];
      var keys = Object.keys(item);
      for (let j = 0; j < keys.length; j++) {
        if (keys[j].startsWith("M_") || keys[j].startsWith("P") || keys[j].startsWith("E_")) {
          let subDevNo = keys[j].split("_")[0];
          result[subDevNo] = item;
        }
      }
    }
  }
  res = await getLastData(devId);
  if (res && res.data) {
    for (let i = 0; i < res.data.length; i++) {
      let item = res.data[i];
      var keys = Object.keys(item);
      for (let j = 0; j < keys.length; j++) {
        if (keys[j].startsWith("M_") || keys[j].startsWith("P")) {
          let subDevNo = keys[j].split("_")[0];
          result[subDevNo] = item;
        }

      }
    }
  }
  return result;
}

export async function getSystemHistory(devId, startTime, endTime) {
  const res = await queryHistory(devId, startTime, endTime);
  if (res.data) {
    let result = res.data.filter(item => {
      return item["E_tv"] !== undefined
    });
    return result.sort((a, b) => {
      return a["time"] - b["time"];
    })
  }
  return [];
}


export async function plantlist(params) {
  return http.get("v1/devices", params)
}
// export async function getPlantDistributeList(userName = "", level = 0) {
//   let owner = getUserName();
//   let filter = {
//     "devtype": "HE_BAT",
//     "subusers": owner,
//   };
//   let newLev = `\\"level\\":${level - 1}`;
//   filter["$or"] = [{
//     "desc": {
//       "$regex": newLev,
//       "$options": "i"
//     }
//   }, {
//     "desc": {
//       "$regex": '\\"' + userName + '\\"',
//       "$options": "i"
//     }
//   }]
//   var res = await plantlist({
//     "skip": 0,
//     "limit": 9999,
//     "filter": JSON.stringify(filter)
//   });
//   if (res == null) {
//     return [];
//   }
//   return res["data"];
// }


export async function singleDeviceTotal(devId) {
  const res = await statistics("62f4b1591283b6002e20fe92", 7);
  // if (res) {
  //   let list = res.data.list.sort((a, b) => {
  //     return a.statisticsTime - b.statisticsTime;
  //   });

  //   list = list.map(item => {
  //     return JSON.parse(item.result)
  //   });
  //   list = list.map(item => {
  //     return [...item[devId]];
  //   });
  //   return list;
  // }
}

export function plantDevice(param = {}, userId) {
  // let filter = {

  //   "$or": [{
  //     "parents": userName
  //   }, {
  //     "subusers": userName
  //   }]
  // };

  return list({
    skip: param.skip,
    limit: param.limit,
    userId
    // filter: JSON.stringify(filter)
  });
  //
}

export async function queryFirstData({infoModelId, begin_time, end_time, category_id, thirdThingsIds, topN, exists}) {

  let userInfo = getLoginData();
    let tenantId = userInfo.tenant_id;

    var res = await http.get(`/v1/data-mgmt/tenants/${tenantId}/info-model/${infoModelId}/things/batch/data`, {
      begin_time,
      end_time,
      category_id,
      thirdThingsIds,
      topN,
      exists
    });
    return res;

  let result = []
  for (let key in fields) {
    result.push(key);
  }
  //{"E_hv":1,"E_lv":1,"E_lt":1,"E_ht":1,"E_soc":1,"E_cur":1,"E_tv":1,"time":1}
  var res = await http.get("v1/devices/" + devId + "/data", {
    "limit": 1,
    "devid": devId,
    "datatype": dataType,
    "devtype": devType,
    "descend": true,
    "fields": JSON.stringify({
      ...fields,
      "time": 1
    }),
    "filter": JSON.stringify({
      [result[0]]: {
        "\$exists": true
      }
    }),
    "skip": 0
  });
  if (res != null && res["data"] != null && res["data"].length > 0) {
    return res["data"][0];
  }
  return null;
}

// infoModelId 为设备类型id，不传则下载全部；返回原始 axios blob 响应供调用方处理文件名
export const downloadThingsFile = (infoModelId) => {
  const userInfo = getLoginData();
  const tid = userInfo.tenant_id;
  const base = `/v1/things/tenants/${tid}/things/download-things-file`;
  const url = infoModelId ? `${base}?infoModelId=${infoModelId}` : base;
  return axios.get(url, { responseType: 'blob' });
}


